import React from 'react'

function ContactForm() {
  return (
    <form action="https://formspree.io/f/mqkrqnjn" method="post">
      <div className="postContactForm">
        <div className="side-by-side">
          <div className="textOnInput">
            <label>FULL NAME</label>
            <input type="text" name="fullName" className="input5"/>
          </div>
        </div>
        <div className="side-by-side">
          <div className="textOnInput">
            <label>EMAIL ID</label>
            <input type="email" name="email" className="input2" />
          </div>
        </div>
        <div className="side-by-side">
          <div className="textOnInput">
            <label>SUBJECT</label>
            <input type="text" name="subject" className="input2" />
          </div>
        </div>
        <div className="side-by-side">
          <div className="textOnInput">
            <label>MESSAGE</label>
            <input type="text" name="message" className="input2"/>
          </div>
        </div>
        <button type='submit' className="createPost" style={{marginTop:'15px'}}>SUBMIT</button>
      </div>
    </form>
  )
}

export default ContactForm
